import "./style.scss"

import 'jquery-form-validator';
import 'master'


var _isMobiClass = 'isMobi',
  _isPopupClass = 'isPopup';
var _isDesktopSize = 1100;
var _inputCheckedClass ='box-checked';

// var loginAPI = [{
//   'username': 'ZZTEST',
//   'password': 'test1234'
// }]

$(window).on('scroll',function(){

});

$(function() {
  $('#field-member-id').val('');
  $('#field-pwd').val('');

  $.validate({
    form: '#form-eshop-login',
    validateOnBlur: false,
    errorMessagePosition: 'inline',
    scrollToTopOnError: false,
    inlineErrorMessageCallback: function inlineErrorMessageCallback($input, errorMessage, config) {
      if ($input.hasClass('error')) {
        $('.comp-error-list p').html('Fail login!');
        $('.comp-error-list').show();
      } else {
        $('.comp-error-list').hide();
      }
    },
    onError: function onError($form) {
      $('.comp-error-list').show();
      toNameAnchor('.comp-error-list');
    },
    onSuccess: function onSuccess($form) {
      var _memberID = $('#field-member-id').val(),
          _memberPwd = $('#field-pwd').val();

      // var _rootEshopAPIurl = (process.env.NODE_ENV == 'production')?  '':'http://13.75.104.238';
      var _rootEshopAPIurl = (process.env.NODE_ENV == 'production')?  '':'http://23.99.125.215';
      var _apiUrl = _rootEshopAPIurl + '/Umbraco/api/Membership/Login';
      var _formData = {
        'username': _memberID,
        'password': _memberPwd
      };

      //add the loading for clicked the login
      var _pgLoader = '<div class="pg-loader"><div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>';
			$('.main').append(_pgLoader);

      $.ajax({
        type: 'POST',
        url: _apiUrl,
        data: _formData,
        dataType: "json",
        contentType: "application/x-www-form-urlencoded",
        success: function success(response) {
          if (response.Code == 200) {
            document.location.href = response.Data.RedirectionUrl;
          } else if (response.Code == 400) {
            $('.comp-error-list p').empty().html('Login Failed, please check your username or password.');
            $('.comp-error-list').show();
            $(".pg-loader").remove();
          }
        }
      });

    },
    onValidate: function onValidate($form) {
      if ($('.comp-error-list p').length <= 0) {
        $('.comp-error-list').hide();
      }
    }
  });

});


function toNameAnchor(target){
  if($(target).length>0){
    $('html, body').delay(200).animate({
            scrollTop: $(target).offset().top-$('header').outerHeight()
    }, 500);
  };
}


function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.href);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, '    '));
};
